import { render, staticRenderFns } from "./invoice-donation.vue?vue&type=template&id=72bde847"
import script from "./invoice-donation.vue?vue&type=script&lang=js"
export * from "./invoice-donation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports